import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import { query } from 'lit/decorators/query.js';
import { localized, msg, str } from "@lit/localize";
import { UsosDialog } from ".";
import style from './help-dialog.scss';
import '../icon/usos-icon';

/**
 * "?" button opening usos-dialog with help.
 *
 * @slot - Slot for usos-dialog content
 */
@customElement('help-dialog')
@localized()
export class HelpDialog extends LitElement {

    static override styles = style;

    /** Title for usos-dialog */
    @property({attribute: 'dialog-title'}) dialogTitle = '';

    @property({attribute: 'aria-label', reflect: true}) override ariaLabel = '';
    @property({reflect: true}) override role = 'button';

    @query('usos-dialog') _dialog!: UsosDialog;

    override render() {
        const title = this.dialogTitle || msg(str `Pomoc`);
        this.ariaLabel = title;
        return html`
            <usos-icon is-button @click=${this.onClick} icon-name="help" .label=${title}></usos-icon>
            <usos-dialog>
                <span slot='title'>${title}</span>
                <slot></slot>
            </usos-dialog>
        `;
    }

    private onClick() {
        this._dialog.open();
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "help-dialog": HelpDialog,
    }
}
